import React from 'react';

/**
 * props: PageResponseVO 필드(pageNo, totalPage, startPage, endPage, hasPrev, hasNext) + onChange(pageNo)
 */
export default function Pagination({ pageNo, totalPage, startPage, endPage, hasPrev, hasNext, onChange }) {
  if (!totalPage || totalPage <= 1) return null;

  const pages = [];
  for (let p = startPage; p <= endPage; p++) pages.push(p);

  return (
    <nav className="pagination" aria-label="페이지 네비게이션">
      <button disabled={!hasPrev} onClick={() => onChange(startPage - 1)}>&laquo;</button>
      <button disabled={pageNo <= 1} onClick={() => onChange(pageNo - 1)}>&lsaquo;</button>
      {pages.map((p) => (
        <button key={p} className={p === pageNo ? 'active' : ''} onClick={() => onChange(p)}>{p}</button>
      ))}
      <button disabled={pageNo >= totalPage} onClick={() => onChange(pageNo + 1)}>&rsaquo;</button>
      <button disabled={!hasNext} onClick={() => onChange(endPage + 1)}>&raquo;</button>
    </nav>
  );
}
